export default __webpack_public_path__ + "static/media/annecy-hightlited-2x.c539af3d.webp";